import React from 'react'
import {Button, Modal, ModalHeader, ModalActions} from '../../UI/index.js'
import {formSpacing, FormStack, Input, MetricInput} from '../../UI/forms/index.js'
import _ from 'lodash'
import type {ParcelProducts} from '../../../../types/types.js'

interface Category {
    name: string
    price: string
    maxWeight: string
    length: number
    width: number
    height: number
    volume: number
    productCode?: string
    priceScales?: {
        price: string
    }[]
}

interface CategoryModalProps {
    remove: (carrier: string, product: ParcelProducts, priceRuleIndex: number, categoryIndex: number) => void
    onChange: (carrier: string, product: ParcelProducts, priceRuleIndex: number, categoryIndex: number, category: Category) => void
}

interface CategoryModalState {
    open: boolean
    carrier?: string
    product?: ParcelProducts
    priceRuleIndex?: number
    categoryIndex?: number
    category: Category
}

class CategoryModal extends React.Component<CategoryModalProps, CategoryModalState> {
    initialState: CategoryModalState

    constructor(props: CategoryModalProps) {
        super(props)
        this.initialState = {
            open: false,
            category: {
                name: '',
                price: '0,00',
                maxWeight: '2',
                length: 0,
                width: 0,
                height: 0,
                volume: 0,
                productCode: '',
                priceScales: [{
                    price: '0,00'
                }]
            }
        }
        this.state = this.initialState
    }

    open(carrier: string, product: ParcelProducts, priceRuleIndex: number, categoryIndex: number, category: Category) {
        this.setState({open: true, carrier, product, priceRuleIndex, categoryIndex, category})
    }

    close() {
        this.setState(this.initialState)
    }

    onChangeMaxWeight(event: React.ChangeEvent<HTMLInputElement>) {
        if (/^$|^[-]{0,1}[0-9]{0,3}$|^[-]{0,1}[0-9]{0,3}[,][0-9]{0,3}$/.test(event.target.value)) {
            const {category} = this.state
            category.maxWeight = event.target.value

            console.log(category)
            this.setState({category})
        }
    }

    onChangeValue(event: React.ChangeEvent<HTMLInputElement>, path: string, parser?: (value: string) => string | number) {
        const category = {...this.state.category}

        const value = typeof parser === 'function' ? parser(event.target.value) : event.target.value

        _.set(category, path, value)

        this.setState({category})
    }

    onRemove() {
        const {carrier, product, priceRuleIndex, categoryIndex} = this.state
        const {remove} = this.props
        if (carrier && product && priceRuleIndex !== undefined && categoryIndex !== undefined) {
            remove(carrier, product, priceRuleIndex, categoryIndex)
        }
        this.close()
    }

    onSubmit() {
        const {carrier, product, priceRuleIndex, categoryIndex, category} = this.state
        const {onChange} = this.props

        // Sort dimensions: length > width > height
        const [length, width, height] = [category.length || 0, category.width || 0, category.height || 0].sort((a, b) => b - a)

        category.length = length
        category.width = width
        category.height = height

        if (carrier && product && priceRuleIndex !== undefined && categoryIndex !== undefined) {
            onChange(carrier, product, priceRuleIndex, categoryIndex, category)
        }
        this.close()
    }

    render() {
        const {open, category, categoryIndex} = this.state

        return (
            <Modal style={{width: 400}} show={open} onClose={this.close.bind(this)}>
                <ModalHeader title='Wijzig categorie' onClose={this.close.bind(this)} style={{marginBottom: 0}} />

                <FormStack style={{marginBottom: formSpacing.rowGap}}>
                    <Input
                        label='Naam'
                        value={category.name || ''}
                        placeholder={category.maxWeight ? `t/m ${category.maxWeight} kg` : `Cat ${(categoryIndex || 0) + 1}`}
                        onChange={(event) => this.onChangeValue(event, 'name')}
                        maxLength={40}
                    />

                    <Input
                        label='Gewicht'
                        value={category.maxWeight}
                        onChange={this.onChangeMaxWeight.bind(this)}
                        append='kg'
                    />

                    <MetricInput
                        label='Lengte'
                        value={category.length}
                        divisionFactor={10}
                        onChange={(event) => this.onChangeValue(event as unknown as React.ChangeEvent<HTMLInputElement>, 'length', parseInt)}
                        append='cm'
                    />

                    <MetricInput
                        label='Breedte'
                        value={category.width}
                        divisionFactor={10}
                        onChange={(event) => this.onChangeValue(event as unknown as React.ChangeEvent<HTMLInputElement>, 'width', parseInt)}
                        append='cm'
                    />

                    <MetricInput
                        label='Hoogte'
                        value={category.height}
                        divisionFactor={10}
                        onChange={(event) => this.onChangeValue(event as unknown as React.ChangeEvent<HTMLInputElement>, 'height', parseInt)}
                        append='cm'
                    />

                    <MetricInput
                        label='Volume'
                        value={category.volume}
                        onChange={(event) => this.onChangeValue(event as unknown as React.ChangeEvent<HTMLInputElement>, 'volume', parseInt)}
                        append='L'
                    />
                </FormStack>

                <br />
                <ModalActions>
                    <Button variant='text' onClick={this.onRemove.bind(this)}>Verwijder</Button>
                    <Button variant='text' onClick={this.onSubmit.bind(this)}>Opslaan</Button>
                </ModalActions>
            </Modal>
        )
    }
}

export default CategoryModal
